import React from "react";
import styled from "styled-components";

import { Splash } from "../../components";

import mountain from "../../img/mathias-jensen-unsplash.jpg";
import developerImage from "../../img/per-loov-unsplash.jpg";
import accomplishmentImage from "../../img/jason-hogan-unsplash.jpg";
import interestImage from "../../img/louis-reed-unsplash.jpg";

const Background = () => {
  return (
    <Wrapper>
      <Item>
        <Splash
          title="Leadership"
          description="The growth and development of people is the highest calling of leadership"
          layout="light"
          copyList={[
            {
              title: "Mentor",
              copy: "I have leaded teams, locally and internationally",
            },
            {
              title: "Teacher",
              copy:
                "Have taught technical class in JavaScript, Testing and React for my fellow coworkers",
            },
            {
              title: "Inspire",
              copy:
                "Constantly learning new technologies to improve my team's life",
            },
          ]}
          image={mountain}
        />
      </Item>
      <Item>
        <Splash
          title="Developer"
          description="Be brave enough to learn something new."
          layout="bright"
          direction="left"
          copyList={[
            {
              title: "Constant is change",
              copy:
                "To keep up with industry, I constantly learn new tools. Not because it's just new, it to be expose to new concept and ideas",
            },
            {
              title: "FrontEnd Experience",
              copy:
                "React, Javascript ES6 and ESNext Standards, Typescript, HTML, CSS, Less, Sass, Hightcharts.js, Charts.js, Backbone.js, JQuery",
            },
            {
              title: "Backend Experience",
              copy:
                "GraphQL, Nodejs, Feather.js, Express, AWS Lambda, Java, MongoDB, SQL, HTTP2, Nginx, Parcels.js, Next.js, Glup, WebPack",
            },
            {
              title: "Testing Experience",
              copy:
                "Jest,Enzyme, React-testing-library, Storybook.js, Mocha, Chai, Sinon.js, Cypress.io, Nightwatch",
            },
          ]}
          image={developerImage}
        />
      </Item>
      <Item>
        <Splash
          title="Accomplishments"
          description="Being acknowledge from others for my hard work."
          layout="light"
          copyList={[
            {
              title: "Webby",
              copy:
                'I was nominated for a webby for my work at "JC Penny first day look campagne"',
              link:
                "http://www.webbyawards.com/winners/2014/social/social-content-and-marketing/fashion-beauty/first-day-look/",
            },
            {
              title: "Hacker Rank",
              copy: "I was certified in Javascript by Hacker Rank",
              link: "https://www.hackerrank.com/certificates/a2adcb57bf07",
            },
            {
              title: "LinkedIn",
              copy:
                "With my continue education efforts, I obtain many Licenses & Certifications",
              link: "https://www.linkedin.com/in/gene-chan/",
            },
          ]}
          image={accomplishmentImage}
        />
      </Item>
      <Item>
        <Splash
          title="Interest"
          description="What drives you to move?"
          layout="bright"
          direction="left"
          copyList={[
            {
              title: "Rasberry Pi",
              copy:
                "The best hobbies are the ones that helps your professional skills like Python.",
            },
            {
              title: "Next.js/Parcel.js",
              copy: "I love new bundle systems that lets me work faster.",
            },
            {
              title: "AI",
              copy: "I currently learning Golang and pytorch",
            },
          ]}
          image={interestImage}
        />
      </Item>
    </Wrapper>
  );
};
const Wrapper = styled.ul`
  padding: 0;
  margin: 0;
  overflow: hidden;
  width: 100%;
`;
const Item = styled.li`
  list-style: none;
`;
export default Background;
